<template>
  <v-layout id="our-team" column class="component-team">
	  <v-flex class="triangle-css"></v-flex>
		<v-layout class="component-our-team" justify-center row align-center>
			<p class="title-our-team">NUESTRO TEAM</p>
			<p class="border-gray"></p>
			<p class="description-our-team">Desarrollamos productos de software , estos tienen un ciclo de vida.  
			Son creados para solucionar un problema en un nicho de mercado específico.</p>
		</v-layout>
		<v-layout class="content-colaborators">
			<v-layout column align-center class="item-collaborator" v-for="(item, index) in collaborators" :key="index">
				<img :src="item.image" alt="" class="image-collaborator">
				<img :src="item.imageColor" class="image-color">
					<v-flex class="background-responsive">
						<p class="name-collaborator-responsive">{{ item.name }}</p>
					</v-flex>
					<p class="name-carge">{{ item.name }}</p>
					<p class="carge">{{ item.carge }}</p>
			</v-layout>
		</v-layout>
	</v-layout>
</template>

<script>
export default {
	name: 'component-our-team',
	props: {
		collaborators: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.component-our-team {
	padding-bottom: 100px;

	@media (max-width: 960px) {
		flex-direction: column;
		padding: 50px 50px 25px 50px;
	}
}

.title-our-team {
	color: map-get($colors, blue-regular);
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: 40px;

	@media (max-width: 960px) {
		text-align: center;
	}
}

.description-our-team {
	color: map-get($colors, gray);
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	font-size: map-get($sizes, large);
	max-width: 552px;

	@media (max-width: 960px) {
		text-align: center;
	}
}

.border-gray {
	background-color:map-get($colors, blue-regular);
	height: 130px;
	margin: 0 37px;
	width: 2px;

	@media (max-width: 960px) {
		display: none;
	}
}

.name {
	color: map-get($colors, regular);
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: map-get($sizes, xlarge);
	margin:  25px 0 0 0;
}

.carge {
	color: map-get($colors, blue-regular);
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	font-size: 15px;

	@media (max-width: 1024px) {
		display: none;
	}
}

.content-colaborators {
	display: grid;
	grid-column-gap: 33.4px;
	grid-row-gap: 52px;
	grid-template-columns: auto auto auto auto;
	margin: 0 auto;

	@media (max-width: 1300px) {
		grid-column-gap: 8px;
		grid-template-columns: auto auto auto;
	}

	@media (max-width: 860px) {
		grid-row-gap: 5px;
		grid-template-columns: auto auto;
	}

	@media (max-width: 450px) {
		grid-template-columns: auto;
	}
}

.image-color {
	position: absolute;

	@media (max-width: 960px) {
		height: 221px;
		width: 170.8px;
	}
}

.image-collaborator {
	z-index: 1;

	&:nth-child(16) {
		grid-column: 2/3;
	}

	@media (max-width: 960px) {
		height: 221px;
		width: 170.8px;
	}
}

.component-team {
	background-color: map-get($colors, background-gray);
	padding: 98px 0;
	position: relative;

	@media (max-width: 1024px) {
		padding: 0;
	}
}

.content-responsive {
	background-color: map-get($colors, base);
	bottom: 40px;
	color: map-get($colors, white);
	opacity: 0.48;
	position: relative;
	width: 100%;
	z-index: 10;
}

.name-carge {
	color: map-get($colors, regular);
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: map-get($sizes, xlarge);
	margin: 24px 0 5px 0;

	@media (max-width: 960px){
		display: none;
	}
}

.triangle-css {
	background-color: map-get($colors, regular);
	height: 130px;
	position: absolute;
	transform: rotate(3deg);
	top: -75px;
	width: 100%;

	@media (max-width: 1024px) {
		display: none;
	}
}

.background-responsive {
	background-color: map-get($colors, base);
	bottom: 36px;
	color: map-get($colors, white);
	opacity: 0.70;
	padding: 10px 0;
	position: relative;
	width: 170px;
	z-index: 4;

	@media (min-width: 960px) {
		display: none;
	}
}

.name-collaborator-responsive {
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: map-get($sizes, medium);
	margin: 0;
	text-align: center;
	z-index: 9;
}

.item-collaborator:hover {
	.image-color {
		z-index: 3;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home/component-our-team.vue